import './Captcha.sass';

import React, { FC, useCallback, useEffect, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { RECAPTCHA_V2_SITE_KEY } from '$shared/constants';
import { useTranslator } from '$hooks';

export const Captcha: FC = () => {
  const t = useTranslator();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const showCaptcha = () => setVisible(true);
    addEventListener('showCaptcha', showCaptcha);

    return () => {
      removeEventListener('showCaptcha', showCaptcha);
    };
  }, []);

  const handleChange = useCallback((token: string | null) => {
    setVisible(false);

    if (token) {
      dispatchEvent(
        new CustomEvent('captchaChange', {
          detail: {
            token,
          },
        }),
      );
    } else {
      dispatchEvent(new CustomEvent('captchaReject'));
    }
  }, []);

  const handleClose = useCallback(() => {
    dispatchEvent(new CustomEvent('captchaReject'));
    setVisible(false);
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <BottomSheet className="Captcha" onClose={handleClose} title={t('captcha_title')}>
      <div className="Captcha__content">
        <ReCAPTCHA
          theme="dark"
          className="Captcha__recaptcha"
          sitekey={RECAPTCHA_V2_SITE_KEY}
          onChange={handleChange}
        />
      </div>
    </BottomSheet>
  );
};
